import { DID_SEARCH, FAILED_TO_SEARCH, RESET_SEARCH, STARTED_TO_SEARCH } from '../constants';
import enhancedFetch from '../utils/fetch-json';

export const fetchAllMunicipalities = async ({ baseUrl, county }) => {
    const fullUrl = `${baseUrl}/api/public/location/${county}/municipalities`;
    const response = await fetch(fullUrl, { method: 'GET' });
    return response.json();
};

export const fetchAllSuburbs = async ({ baseUrl, municipality }) => {
    const fullUrl = `${baseUrl}/api/public/location/${municipality}/suburbs`;
    const response = await fetch(fullUrl, { method: 'GET' });
    return response.json();
};

export const fetchAllCounties = async ({ baseUrl }) => {
    const response = await fetch(`${baseUrl}/api/public/location/counties`);
    return response.json();
};

export const search =
    (query, useSemanticSearch) =>
    ({ dispatch, getState }) => {
        dispatch({ type: STARTED_TO_SEARCH });
        const state = getState();

        const type = useSemanticSearch ? '/search/semantic' : '/search';
        const fullUrl = `${state.baseURL}/api/public${type}?q=${encodeURIComponent(query)}`;

        return enhancedFetch({ url: fullUrl, dispatch, getState })
            .then((response) => {
                dispatch({
                    type: DID_SEARCH,
                    data: response.body,
                });
                return response.body;
            })
            .catch((error) => {
                dispatch({
                    type: FAILED_TO_SEARCH,
                    data: error.body,
                });
            });
    };

export const resetSearch =
    () =>
    ({ dispatch }) => {
        dispatch({ type: RESET_SEARCH });
    };
